module.exports = require("./pt-AO");